import React from "react";
import useAddRef, { UseAddRefOptions } from "./useAddRef";
import { useIcon } from "@SeemplicityDev/shared";

const Header: React.FC<UseAddRefOptions> = ({ addRef }) => {
  const ref = useAddRef({ addRef });
  const { getSvg } = useIcon("DARK");
  return (
    <div className={"header no-margin"} ref={ref}>
      <h1 className="title">Year in Review - Report 2025</h1>
      <img src={getSvg("logo")} alt={"Seemplicity logo"} className={"logo"} />
    </div>
  );
};

export default Header;
